module.exports = __webpack_public_path__ + "static/media/UploadIconBlue.cc37d1be.svg";